import React from 'react';
import classnames from 'classnames';
import * as s from './dre.scss';
var DRE = function (_a) {
    var environment = _a.environment, dre = _a.dre;
    // no DRE available on testkit
    if (process.env.NOVM) {
        return null;
    }
    // TODO: integrate dumpid / dumptoken once they are being passed down to frontend T44607
    var url = "https://admin.deviantart." + (environment === 'dev' ? 'lan' : 'com') + "/dre/share?dumpid=" + (dre === null || dre === void 0 ? void 0 : dre.dumpId) + "&token=" + (dre === null || dre === void 0 ? void 0 : dre.dumptoken);
    var openWindow = function () {
        var win = window.open(url, 'DRE_Console', "left=100,top=225,width=" + Math.round(document.body.offsetWidth * 0.8) + ",height=" + Math.round(screen.height * 0.7) + ",toolbar = 0, scrollbars = 1, location = 0, status = 0, statusmenubar = 0, resizable = 1");
        if (!win) {
            return alert('DRE window has been blocked as a popup');
        }
        win.focus();
    };
    var wrapEvent = function (eventCount, label) {
        if (!eventCount) {
            return "0" + label;
        }
        return (React.createElement("span", null,
            React.createElement("strong", null, eventCount),
            label));
    };
    return (React.createElement("div", { className: classnames(s['root'], (dre === null || dre === void 0 ? void 0 : dre.alarmEvents) && (dre === null || dre === void 0 ? void 0 : dre.alarmEvents) > 0 && s['alert']), onClick: openWindow }, dre === null || dre === void 0 ? void 0 :
        dre.hostname,
        " ", dre === null || dre === void 0 ? void 0 :
        dre.totaltime,
        "ms ",
        React.createElement("br", null),
        React.createElement("span", { className: s['alarms'] }, wrapEvent(dre === null || dre === void 0 ? void 0 : dre.alarmEvents, 'A')),
        ' ',
        wrapEvent(dre === null || dre === void 0 ? void 0 : dre.warningEvents, 'W'),
        " ",
        wrapEvent(dre === null || dre === void 0 ? void 0 : dre.noticeEvents, 'N'),
        ' ',
        (dre === null || dre === void 0 ? void 0 : dre.myEvents) && wrapEvent(dre === null || dre === void 0 ? void 0 : dre.myEvents, 'M'),
        ' ',
        (dre === null || dre === void 0 ? void 0 : dre.quickEvents) && wrapEvent(dre === null || dre === void 0 ? void 0 : dre.quickEvents, 'Q'),
        ' ',
        wrapEvent(dre === null || dre === void 0 ? void 0 : dre.infoEvents, 'T')));
};
DRE.displayName = 'DRE';
export default DRE;
//# sourceMappingURL=dre.js.map